import { render, staticRenderFns } from "./started-footer.vue?vue&type=template&id=2cc57596&scoped=true&"
import script from "./started-footer.vue?vue&type=script&lang=js&"
export * from "./started-footer.vue?vue&type=script&lang=js&"
import style0 from "./started-footer.vue?vue&type=style&index=0&id=2cc57596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc57596",
  null
  
)

export default component.exports